import urlapi from 'url';
import { GistData } from '@nx-frontend/shared/types';

const googleApiKey = 'AIzaSyBtcUZ2bqXlsRLDA9SYkvs-xx_DkORt7yc'; //TODO: ключ апи для тестов, в дальнейшем нужно изменить на нормальный

export const iFramePattern = /<iframe.*?s*src=["|'](.*?)["|'].*?<\/iframe>/;
export const videoSrcPattern = /<video.*?s*src=["|'](.*?)["|'].*?<\/video>/m;

const nimbusSharePattern = /^https?:\/\/[.a-zA-Z0-9_-]+(\/s)?\/share\/[0-9]+\/[a-zA-Z0-9_]+(\/.+)?/;
const nimbusShareShortPattern = /^https?:\/\/nimb\.ws\/[a-zA-Z0-9_]+(\/)?/;

// тут сразу делаем проверку строки и в случае если строка не пройдет проверки возвращаем false
export function deserializeEmbedString(string: string) {
  const specEmbedSrc = parseSpecEmbed(string);
  if (specEmbedSrc) {
    return specEmbedSrc;
  }
  const isUrlPattern =
    /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
  const hasProtocolPattern = /^https?:\/\//;
  const match = string.match(iFramePattern);

  if (match && match[1] && match[1].length) {
    return match[1];
  } else {
    const isUrl = Boolean(string.match(isUrlPattern));
    if (isUrl) {
      const hasProtocol = Boolean(string.match(hasProtocolPattern));
      if (!hasProtocol) {
        return 'http://' + string;
      } else {
        return string;
      }
    } else {
      return '';
    }
  }
}

export function isLinkToPdfFile(url: string) {
  const pattern = /^(https?:\/\/)?(www\.)?([\da-z.-]+)\.([a-z.]{2,6})\/[\w .-/%]+?\.pdf$/;
  return pattern.test(encodeURI(url));
}

const jsonpCallbackRegistry: Record<string, unknown> = {};
export function scriptRequest(
  url: string,
  callbackName: string,
  onSuccess: (data: GistData) => void,
  onError: (url: string) => void
) {
  let scriptOk = false;
  const script: HTMLScriptElement = document.createElement('script');

  url += ~url.indexOf('?') ? '&' : '?';
  url += 'callback=jsonpCallbackRegistry.' + callbackName;

  jsonpCallbackRegistry[callbackName] = function (data: GistData) {
    scriptOk = true;
    delete jsonpCallbackRegistry[callbackName];
    onSuccess(data);
    script.parentNode?.removeChild(script);
  };

  function checkCallback() {
    if (scriptOk) return;
    delete jsonpCallbackRegistry[callbackName];
    onError(url);
    script.parentNode?.removeChild(script);
  }

  script.onload = script.onerror = checkCallback;
  script.src = url;

  document.body.appendChild(script);
}

export function getGoogleMapsEmbedSrc(url: string) {
  const parsed = urlapi.parse(url);
  const query = parsed.query || '';
  const urlParams = new URLSearchParams(query);

  if (urlParams.has('q')) {
    const q = String(urlParams.get('q'));
    return 'https://www.google.com/maps/embed/v1/place?key=' + googleApiKey + '&q=' + q;
  } else if (urlParams.has('pb')) {
    const pb = String(urlParams.get('pb'));
    return 'https://www.google.com/maps/embed?pb=' + pb;
  } else if (urlParams.has('mid')) {
    // mid = map id - если указан этот параметр, то карта создана юзером
    const mid = String(urlParams.get('mid'));
    return 'https://www.google.com/maps/d/embed?mid=' + mid;
  } else {
    const pathArr = parsed?.path?.split('/');
    const coords = url.match(/@(.*?),(.*?),/);
    if (pathArr?.indexOf('place') !== -1) {
      const queryString = pathArr?.[pathArr.indexOf('place') + 1];
      if (queryString) {
        return 'https://www.google.com/maps/embed/v1/place?q=' + queryString + '&key=' + googleApiKey;
      } else {
        return url;
      }
    } else if (coords) {
      return (
        'https://www.google.com/maps/embed/v1/view?center=' +
        coords[1] +
        ',' +
        coords[2] +
        '&key=' +
        googleApiKey +
        '&zoom=17'
      );
    } else {
      return url;
    }
  }
}

export function getYoutubeFrameStartTime(url: string) {
  const query = urlapi.parse(url).search;
  if (query) {
    const searchParams = new URLSearchParams(query);
    if (searchParams.has('t')) {
      return searchParams.get('t');
    } else if (searchParams.has('start')) {
      return searchParams.get('start');
    } else {
      return false;
    }
  }
  return false;
}

function isLitresEmbed(string: string) {
  const scriptPattern =
    /(<div(\s(.+)?\s?class="litres_fragment_body"\s(.+)?><\/div>))?<script.+lw\.src\s?=\s?"https:\/\/www\.litres\.ru\/static\/widgets\/js\/fragment\.js".+<\/script>/;
  const bookIdPattern = /<script.+var\slitres_fragment_book_view_id\s?=\s?(\d+);.+<\/script>/;
  const partnerIdPattern = /<script.+var\slitres_fragment_lfrom\s?=\s?(\d+);.+<\/script>/;

  let match = string.match(bookIdPattern);
  const bookId = match && match[1];
  if (!bookId) return '';
  match = string.match(partnerIdPattern);
  let partnerId = match && match[1];
  if (!partnerId) {
    partnerId = '123456';
  }

  if (scriptPattern.test(string)) {
    return (
      'https://www.litres.ru/pages/quickread/?art=' +
      bookId +
      '&skin=normal&lfrom=' +
      partnerId +
      '&widget=1.00&iframe=1'
    );
  } else {
    return '';
  }
}

export function isCodepenEmbed(string: string) {
  const htmlPattern = /<p class="codepen" .+<\/p>.*<script async src="https:\/\/static\.codepen\.io.+><\/script>/s;
  const linkPattern = /(https?:\/\/)?codepen.io\/(.+)\/(pen|embed)(\/preview)?\/(\w+)/;
  const attrsPattern = /data-[\w-]+="[\w, -]+"/g;
  const forIframeAttrs = ['height', 'theme-id', 'default-tab'];
  const match = string.match(linkPattern);
  let result = '';
  if (match && match[2] && match[5]) {
    result = 'https://codepen.io/' + match[2] + '/embed/' + (match[4] ? 'preview/' : '') + match[5];
    const isHtml = htmlPattern.test(string);
    if (isHtml) {
      const attrs = string.match(attrsPattern);
      let withPreview = false;
      if (attrs?.length) {
        const filteredAttrs = attrs
          .map((attr) => attr.replace('data-', '').replace('"', ''))
          .filter((attr) => {
            if (attr.startsWith('preview')) {
              withPreview = true;
            }
            return forIframeAttrs.includes(attr.split('=')[0]);
          });
        if (withPreview) {
          result = 'https://codepen.io/' + match[2] + '/embed/preview/' + match[4];
        }
        if (filteredAttrs.length) {
          result += '?';
          for (const attr of attrs) {
            result += attr;
          }
        }
      }
    }
  }
  return result;
}

function isTwitterEmbed(string: string) {
  const htmlPattern = /(https?:)?(\/\/)?twitter\.com\/[^/]+\/status\/[^/]+\?/;
  const match = string.match(htmlPattern);
  if (match && match.length) {
    return match[0].slice(0, -1);
  }
  return '';
}

function isTiktokEmbed(string: string) {
  const htmlPattern = /(https?:\/\/)?(m\.|www\.)?tiktok.com\/.+\/video\/[0-9]+/;
  const match = string.match(htmlPattern);
  if (match && match.length) {
    return match[0];
  }
  return '';
}

function isInstagramEmbed(string: string) {
  const htmlPattern = /(https?:\/\/)(www\.)?instagram.com\/(p|reel|tv)\/.{11}/;
  const match = string.match(htmlPattern);
  if (match && match.length) {
    return match[0] + '/embed';
  }
  return '';
}

function parseSpecEmbed(string: string) {
  const specFns = [isLitresEmbed, isCodepenEmbed, isTwitterEmbed, isTiktokEmbed, isInstagramEmbed];
  let result = '';
  for (const fn of specFns) {
    result = fn(string);
    if (result) {
      break;
    }
  }
  return result;
}

export function isNimbusVideoEmbed(src: string, html: string) {
  return (nimbusSharePattern.test(src) || nimbusShareShortPattern.test(src)) && videoSrcPattern.test(html);
}

export function decodeHtmlEntities(string: string) {
  const txt = document.createElement('textarea');
  txt.innerHTML = string;
  const result = txt.value;
  txt.remove();
  return result;
}
